import {
  PayrollScheduleDayOfWeek,
  PayrollScheduleFrequency,
  PayrollScheduleUpdate
} from "@wingspanhq/wingspan-api-sdk";
import {
  PayrollCadenceFormData,
  PayrollCadenceOption
} from "../components/FieldsPayrollCadence/types";
import { WeekDay } from "../types/time";

const weekDayToScheduleDayOfWeek: Record<WeekDay, PayrollScheduleDayOfWeek> = {
  [WeekDay.Monday]: PayrollScheduleDayOfWeek.MONDAY,
  [WeekDay.Tuesday]: PayrollScheduleDayOfWeek.TUESDAY,
  [WeekDay.Wednesday]: PayrollScheduleDayOfWeek.WEDNESDAY,
  [WeekDay.Thursday]: PayrollScheduleDayOfWeek.THURSDAY,
  [WeekDay.Friday]: PayrollScheduleDayOfWeek.FRIDAY,
  [WeekDay.Saturday]: PayrollScheduleDayOfWeek.SATURDAY,
  [WeekDay.Sunday]: PayrollScheduleDayOfWeek.SUNDAY
};

/**
 * The `PATCH /payroll-schedules/:type` body for a cadence the payer picked.
 *
 * `dayOfWeek` is only meaningful for a weekly cadence — the other three
 * frequencies land on dates the backend derives — so it is sent only with
 * `Weekly`, and `interval` is pinned to 1 for them.
 */
export const selectorPayrollScheduleUpdate = (
  cadence: PayrollCadenceFormData
): PayrollScheduleUpdate => {
  if (cadence.interval === PayrollCadenceOption.Week) {
    return {
      frequency: PayrollScheduleFrequency.WEEKLY,
      interval: cadence.every,
      dayOfWeek: weekDayToScheduleDayOfWeek[cadence.dayInInterval]
    };
  }

  return {
    frequency:
      cadence.interval === PayrollCadenceOption.Everyday
        ? PayrollScheduleFrequency.DAILY
        : cadence.interval === PayrollCadenceOption.SemiMonthly
          ? PayrollScheduleFrequency.SEMI_MONTHLY
          : PayrollScheduleFrequency.MONTHLY,
    interval: 1
  };
};
